type StrikeReportColumnParams = {
  data: any;
  hasNoChildren: boolean;
};

export interface StrikeReportColumn {
  id: string;
  label: string;
  children?: StrikeReportColumn[];
}

export const getStrikeReportColumns = ({
  data,
  hasNoChildren,
}: StrikeReportColumnParams): StrikeReportColumn[] => {
  if (!data) {
    return [];
  }

  const expiryDates: string[] = data.expiry_dates;
  const hierarchy = data.hierarchy;

  if (hasNoChildren) {
    return expiryDates.map((expiry) => ({ id: expiry, label: expiry }));
  }

  const singleVenue = Object.keys(hierarchy).length === 1;

  return expiryDates.map((expiry) => {
    let children: StrikeReportColumn[];

    if (singleVenue) {
      const venue = Object.keys(hierarchy)[0];
      children = (hierarchy[venue] as string[]).map((book: string) => ({
        id: `${expiry}-${venue}-${book}`,
        label: book,
      }));
    } else {
      children = Object.keys(hierarchy).map((exchange) => ({
        id: `${expiry}-${exchange}`,
        label: exchange,
        children: (hierarchy[exchange] as string[]).map((book: string) => ({
          id: `${expiry}-${exchange}-${book}`,
          label: book,
        })),
      }));
    }

    return { id: expiry, label: expiry, children };
  });
};
